export default __webpack_public_path__ + "static/media/7.44ce9f92.jpeg";